// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-size: 44px;
  color: #234769;
  font-weight: 600;
}

.card-container {
  gap: 50px;
  margin: 3rem;
}

@media screen and (max-width: 992px) {
  .title {
    font-size: 24px;
  }
  .card-container {
    margin: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/views/complete/components/upsales-container/upsales-container.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AACA;EACE,SAAA;EACA,YAAA;AAEF;;AACA;EACE;IACE,eAAA;EAEF;EACA;IACE,YAAA;EACF;AACF","sourcesContent":[".title {\r\n  font-size: 44px;\r\n  color: #234769;\r\n  font-weight: 600;\r\n}\r\n.card-container {\r\n  gap: 50px;\r\n  margin: 3rem;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .title {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .card-container {\r\n    margin: 2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
